export default class RequestStoreDisplayType {
    static CARD = 1;
    static TABLE = 2;
}
